import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataCollection } from '../../../models/site-content/data-collection.model';
import { EventSubscription } from '../../../models/event-subscription.model';
import { Folder } from '../../../models/site-content/folder.model';
import { FormInstance } from '../../../models/site-content/form-instance.model';
import { FormInstanceFilter } from '../../../models/notifications/form-instance-filter.model';
import { EventSubscriptionService } from '../../../services/event-subscription.service'
import { AncestorFolderFilter } from '../../../models/notifications/ancestor-folder-filter.model';
import { EventNameEnum } from '../../../enums/event-subscription.enum';
import { SubscriptionFilter } from '../../../models/notifications/subscription-filter.model';

@Component({
    selector: 'app-subscribe-to-workflow-transition',
    templateUrl: './subscribe-to-workflow-transition.dialog.html',
    styleUrls: ['./subscribe-to-workflow-transition.dialog.scss'],
    standalone: false
})
export class SubscribeToWorkflowTransitionDialog implements OnInit {

    private title: string;
    private formInstance: FormInstance;
    private folder: Folder;
    private site: DataCollection;
    private entity: string;
    private subscriptions: EventSubscription[];
    private checkingSubscriptions: boolean = false;

    constructor(
        public selfRef: MatDialogRef<SubscribeToWorkflowTransitionDialog>,
        @Inject(MAT_DIALOG_DATA) public inputData,
        private eventSubscriptionService: EventSubscriptionService
    ) { }

    ngOnInit(): void {
        this.checkingSubscriptions = true;
        this.formInstance = this.inputData.formInstance;
        this.folder = this.inputData.folder;
        this.site = this.inputData.site;
        this.initProperties();
    }
    private initProperties(): void {
        this.subscriptions = this.getSubscriptions();

        let prefix = "Subscribe to Workflow Actions for";
        if (this.FormInstance) {
            this.entity = 'Form';
            this.title = `${prefix} Form ${this.formInstance.name}`;
        } else if (this.Folder) {
            this.entity = 'Folder';
            let name = this.folder.name == 'Root' ? 'All Form Instances' : ` Folder "${this.folder.name}"`;
            this.title =`${prefix} ${name}`;
        } else {
            this.entity = 'Data Collection'
            this.title =`${prefix} Data Collection ${this.site.name}`;
        }
    }

    private getSubscriptions(): EventSubscription[] {
        if (this.formInstance) {
            this.eventSubscriptionService.getFormInstanceSubscriptions(EventNameEnum.FormInstance_Workflow_Transition, this.formInstance).then(x => {
                this.subscriptions = x;
                this.checkingSubscriptions = false;
            });
        } else if (this.folder) {
            this.eventSubscriptionService.getFolderSubscriptions(EventNameEnum.FormInstance_Workflow_Transition, this.folder).then(x => {
                this.subscriptions = x;
                this.checkingSubscriptions = false;
            });
        } else {

        }

        return null;
    }

    public get CheckingSubscriptions(): boolean {
        return this.checkingSubscriptions;
    }

    public isSubscribed(): boolean {
        //console.log(this.subscriptions);
        return this.subscriptions && this.subscriptions.length > 0;
    }

    // TODO: rethink the implementation of this to accomdate multiple subscriptions - currently operating on the assumption that there will only be one
    // which is true with the initial implementation of worflow subscriptions
    public get IsExactMatch(): boolean {
        //  true if ANY of the entity's subscriptions are an exact match
        return this.subscriptions?.filter(x => { return x.isExactMatch }).length > 0;
    }

    public get IsMatchedByAncestor(): boolean {
        //  true if NONE of the entity's subscriptions are an exact match
        return this.subscriptions?.filter(x => { return x.isExactMatch }).length == 0;
    }

    public get SubscribedEntityName(): string {
        if (!this.subscriptions || this.subscriptions.length == 0) {
            return null;
        } else {
            return this.subscriptions[0].entityName;
        }
    }

    public get SubscribedEntityPath(): string {
        if (!this.subscriptions || this.subscriptions.length == 0) {
            return null;
        } else {
            return this.subscriptions[0].entityPath;
        }
    }

    public get Entity(): string {
        return this.entity;
    }

    public get FormInstance(): FormInstance {
        return this.formInstance;
    }

    public get Folder(): Folder {
        return this.folder;
    }

    public get Site(): DataCollection {
        return this.site;
    }

    public get Subscriptions(): EventSubscription[] {
        return this.subscriptions;
    }

    public get Title(): string {
        return this.title;
    }

    public subscribe(): void {
        let workflowTransitionEventSubscription = new EventSubscription();
        if (this.formInstance) {
            workflowTransitionEventSubscription.dataCollectionId = this.formInstance.dataCollectionId;
            workflowTransitionEventSubscription.formInstanceId = this.formInstance.id;
            workflowTransitionEventSubscription.subscribeeType = 'UserMaxId';
            workflowTransitionEventSubscription.eventName = EventNameEnum.FormInstance_Workflow_Transition;
            let filter = new SubscriptionFilter('FormInstanceFilter');
            filter.formInstanceId = this.formInstance.id;
            filter.eventName = workflowTransitionEventSubscription.eventName;
            workflowTransitionEventSubscription.addFilter(filter);

            let manuallyTriggeredSubscription = new EventSubscription();
            manuallyTriggeredSubscription.dataCollectionId = this.formInstance.dataCollectionId;
            manuallyTriggeredSubscription.formInstanceId = this.formInstance.id;
            manuallyTriggeredSubscription.subscribeeType = 'UserMaxId';
            manuallyTriggeredSubscription.eventName = EventNameEnum.FormInstance_Manually_Triggered;
            let manualFilter = new SubscriptionFilter('FormInstanceFilter');
            manualFilter.formInstanceId = this.formInstance.id;
            manualFilter.eventName = EventNameEnum.FormInstance_Manually_Triggered;
            manuallyTriggeredSubscription.addFilter(manualFilter);

            this.eventSubscriptionService.subscribe([workflowTransitionEventSubscription, manuallyTriggeredSubscription]).then(x => { });
        } else if (this.folder) {
            let filter = new SubscriptionFilter('AncestorFolderFilter');
            filter.folderId = this.folder.id;

            workflowTransitionEventSubscription.dataCollectionId = this.folder.dataCollectionId;
            workflowTransitionEventSubscription.folderId = this.folder.id;
            workflowTransitionEventSubscription.subscribeeType = 'UserMaxId';
            workflowTransitionEventSubscription.eventName = EventNameEnum.FormInstance_Workflow_Transition;
            workflowTransitionEventSubscription.addFilter(filter);

            // TODO: this should only be created if user checks "notify me when forms added to this folder"
            var formAddedToFolderEventSubscription = new EventSubscription();
            formAddedToFolderEventSubscription.dataCollectionId = this.folder.dataCollectionId;
            formAddedToFolderEventSubscription.folderId = this.folder.id;
            formAddedToFolderEventSubscription.subscribeeType = 'UserMaxId';
            formAddedToFolderEventSubscription.eventName = EventNameEnum.FormInstance_Added_To_Folder;
            formAddedToFolderEventSubscription.addFilter(filter);

            let manuallyTriggeredSubscription = new EventSubscription();
            manuallyTriggeredSubscription.dataCollectionId = this.folder.dataCollectionId;
            manuallyTriggeredSubscription.subscribeeType = 'UserMaxId';
            manuallyTriggeredSubscription.eventName = EventNameEnum.FormInstance_Manually_Triggered;
            manuallyTriggeredSubscription.addFilter(filter);

            this.eventSubscriptionService.subscribe([workflowTransitionEventSubscription, formAddedToFolderEventSubscription, manuallyTriggeredSubscription]).then(x => { });
        } else {
            alert('SubscribeToWorkflowTransitionDialog: Subscribing to DataCollection not yet supported');
        }
        this.selfRef.close(null);
    }

    public unsubscribe(): void {
        // Only unsubscibe on those that are an exact match for the current Entity (this avoids accidently unsubscribing from one on an ancestor)
        let subscriptionsToUnsubscribeFrom = this.subscriptions.filter(x => { return x.isExactMatch });
        this.eventSubscriptionService.unsubscribe(subscriptionsToUnsubscribeFrom).then();
        this.selfRef.close(null);
    }

    public cancel(): void {
        this.selfRef.close(null);
    }

    private generateTitle(): string {
        let prefix = "Subscribe to Workflow Actions for";
        if (this.FormInstance) {
            return `${prefix} Form ${this.formInstance.name}`;
        } else if (this.Folder) {
            let name = this.folder.name == 'Root' ? 'All Form Instances' : ` Folder "${this.folder.name}"`;
            return `${prefix} ${name}`;
        } else {
            return `${prefix} Data Collection ${this.site.name}`;
        }
    }

}
